// @flow

import _ from 'lodash';

import { NativeError } from './js/native-error';
import { Error } from './js/error';
import type { ErrorOptions } from './js/error';

import { enrich } from './js/enrich';

export { Error } from './js/error';
export { enrich } from './js/enrich';

// FRAGILE: Error thrown by ajax (e.g. from server2) won't have 'stack' prop in IE11
export function isErrorAlike (x: mixed): boolean {
	return Boolean(
		x
			&& x.name
			&& x.message
			&& x.stack
	);
}

export function isLikeApiRelatedError (x: mixed): boolean {
	const isFromBackendError = Boolean(
		x
			&& _.has(x, 'code')
			&& _.has(x, 'handled')
			&& _.has(x, 'response')
	);

	if (isFromBackendError) {
		return true;
	}

	// api errors without response (Network request failed, Gateway Time-out)
	const connectionErrorCodes = ['RGSRUUI-01000', 'RGSRUUI-01002'];
	return _.includes(connectionErrorCodes, x.code);
}

export function fromErrorAlike (x: Object): Error {
	return fromNative(x);
}

export function isNative (x: mixed): boolean {
	return Boolean(x && x instanceof NativeError);
}

export function fromNative (nativeError: Object, defaultOptions?: ErrorOptions): Error {
	if (nativeError instanceof Error) {
		return nativeError;
	}

	const customError = new Error(nativeError.message, defaultOptions);

	_.extend(customError, _.pickBy(_.pick(nativeError, [
		'name',
		'stack',
		'code',
		'handled',
		'response',
		'fileupload',
		'event',
		'userFriendlyMessages',
		'correlationIds',
	]), Boolean));

	return customError;
}

export function enrichNative (nativeError: Object): Error {
	const error = fromNative(nativeError);
	enrich(error);
	return error;
}

export function ignoreHandledErrors (e: Error) {
	if (e.handled) {
		return;
	}
	throw e;
}

// Использовать только в крайних случаях (по ФТ)
// Только в случае когда не нужны НИКАКИЕ нотификации на ошибку, что бывает крайне редко
export function ignoreAllErrors (e: Error) {
	e.handled = {
		type: 'silently',
	};
}
